import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import './Home.css';

function Home() {
  // Get current domain dynamically (works for both www and non-www)
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://sharvalabs.com';
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Sharva Labs",
    "url": baseUrl,
    "description": "Text analysis and word frequency tools for content insights",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${baseUrl}/word-analyzer`,
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <SEO
        title="Sharva Labs - Text Analysis & Word Frequency Tools"
        description="Innovative solutions for text analysis and data processing. Analyze text and discover the most frequent meaningful words with our advanced word frequency analysis tool."
        path="/"
        keywords="text analysis, word frequency analyzer, content analysis, text processing tools, word counter, stop word filtering"
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <div className="home-container">
      <div className="hero-section">
        <h1 className="hero-title">Welcome to Sharva Labs</h1>
        <p className="hero-subtitle">
          Innovative solutions for text analysis and data processing
        </p>
        <div className="hero-actions">
          <Link to="/word-analyzer" className="cta-button primary">
            Try Word Analyzer
          </Link>
        </div>
      </div>

      <div className="features-section">
        <h2 className="section-title">Our Tools</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Word Analyzer</h3>
            <p>Analyze text and discover the most frequent meaningful words. Get insights into your content with our advanced word frequency analysis tool.</p>
            <Link to="/word-analyzer" className="feature-link">
              Try it now →
            </Link>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3>Coming Soon</h3>
            <p>More powerful tools and features are on the way. Stay tuned for updates!</p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Home;

